import i18next, { Resource, ResourceKey } from 'i18next';
import { initReactI18next } from 'react-i18next';

import { DEFAULT_LANG } from '_utils/script';

const files = import.meta.glob<{ default: ResourceKey }>('./*/*.json', {
  eager: true,
});

const getResources = (): Resource => {
  const resources: Resource = {};

  for (const path in files) {
    const match = path.match(/^\.\/([^/]+)\/(.+)\.json$/);

    if (!match) continue;

    const [, lang, namespace] = match;

    resources[lang] ??= {};
    resources[lang][namespace] = files[path].default;
  }

  return resources;
};

i18next.use(initReactI18next).init({
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
  lng: DEFAULT_LANG,
  load: 'languageOnly',
  resources: getResources(),
});

export const setLanguage = (lang: string) => {
  i18next.changeLanguage(lang);
};

export default i18next;
